import classNames from 'clsx';
import React from 'react';

import Button from '@swf/components/StarsButton/StarsButton';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import styles from './Arrow.scss';

// TODO: provide props to the FC 😡
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CrmArrow: React.FC<any> = (props) => {
  const { slideCount, currentSlide, ...rest } = props;
  return (
    <Button {...rest} className={classNames(props.className, styles.button)} icon={<Arrow />} />
  );
};
